import { ConversationsService } from "@/generated";
import { downloadCsv } from "@/utils/csv";
import { ANALYTICS_EVENTS, analytics_track } from "@/utils/mixpanel";

export enum PastChatsExport {
  Conversations = "conversations",
  Feedback = "feedback",
}

export type ConversationFilterScope = {
  assistant_id?: string;
  deployment_id?: string;
  from_date?: string;
  to_date?: string;
  has_feedback?: boolean;
};

export type PastChatsSelection = ConversationFilterScope & {
  conversation_ids?: string[];
  expected_count?: number;
};

/** Download past chats, or their rated replies, as a CSV saved in the browser,
 * and record the export. The Past chats page and Genie both export through it. */
export async function exportPastChats(
  groupId: string,
  kind: PastChatsExport,
  body: PastChatsSelection
): Promise<void> {
  const feedback = kind === PastChatsExport.Feedback;
  const res = feedback
    ? await ConversationsService.bulkExportFeedbackCsv({
        path: { group_id: groupId },
        body,
        responseType: "text",
      })
    : await ConversationsService.bulkExportConversationsCsv({
        path: { group_id: groupId },
        body,
        responseType: "text",
      });
  downloadCsv(kind, (res.data as unknown as string) || "");
  analytics_track(
    feedback
      ? ANALYTICS_EVENTS.MESSAGE_FEEDBACK_EXPORTED
      : ANALYTICS_EVENTS.CONVERSATIONS_EXPORTED,
    { count: body.conversation_ids?.length ?? body.expected_count }
  );
}
